import { Context } from '@nuxt/types'
import { logger } from '@ustra/core'
import * as ConstKeys from '@hds/help-common/src/utils/constant-keys'
import vencdEventBus from '~/event-bus/vencd-event-bus'

export default (ctx: Context, _cb) => {
  // VenCd 체크
  if (ctx.$ustra.hs.store.auth.currentUser.userGbcd === ConstKeys.ADMIN_ROLE && ctx.$ustra.hs.store.auth.currentUser.venCd === null) {
    vencdEventBus.emit({ activeAlert: true })
  } else {
    _cb()
  }
}
